import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildLegalHead } from "@/lib/legalSeo";

export const Route = createFileRoute("/privacy-policy")({
  head: () => buildLegalHead("/privacy-policy"),
  component: lazyRouteComponent(() => import("@/pages/PrivacyPolicy")),
});
